<div class="container container-shadow mt-3 mb-5 py-5">
  <div *ngIf="loading" class="text-center"><i class="fas fa-fw fa-spinner fa-pulse fa-5x"></i></div>
  <div *ngIf="!loading">
    <h3 class="mb-3">
      Withheld Income Taxes -&nbsp;
      <app-badge badgeType="primary">{{ count }}</app-badge>
    </h3>
    <div class="mb-3">
      <button type="button" [disabled]="loading" (click)="loadWithheldIncomeTaxes()" class="btn btn-outline-primary">
        <i class="fas fa-sync" [ngClass]="{ 'fa-spin': loading }"></i>
      </button>
      &nbsp;
      <button type="button" (click)="openNewWithheldIncomeTax()" class="btn btn-outline-primary">
        <i class="fas fa-plus"></i>
        New Withheld Income Tax
      </button>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th>Id</th>
          <th>Marital Status</th>
          <th>Min Wage</th>
          <th>Max Wage</th>
          <th>Base</th>
          <th>Rate</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let withheldIncomeTax of withheldIncomeTaxes">
          <td>
            <a [routerLink]="'/withheld_income_taxes/' + withheldIncomeTax.id + '/edit'"><i class="fas fa-pencil-alt"></i></a>
            {{ withheldIncomeTax.id }}
          </td>
          <td>{{ withheldIncomeTax.is_married ? 'Yes' : 'No' }}</td>
          <td>{{ withheldIncomeTax.min || 0.0 | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
          <td>
            <span *ngIf="withheldIncomeTax.max">{{ withheldIncomeTax.max || 0.0 | currency: 'USD':'symbol-narrow':'1.2-2' }}</span>
          </td>
          <td>{{ withheldIncomeTax.base || 0.0 | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
          <td>
            <span *ngIf="withheldIncomeTax.rate">{{ withheldIncomeTax.rate || 0.0 }}%</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
